/* =========================================================================
   Unitree PUMP — V2 共有スクリプト
   nav 收缩/毛玻璃 · 移动菜单 · 滚动 reveal · 锚点高亮 · hero 分镜 · 数字递增
   ========================================================================= */
(function () {
  "use strict";

  /* ---------- NAV: 滚动收缩 + 背景渐显毛玻璃 ---------- */
  var nav = document.querySelector(".nav");
  var forceSolid = document.body.classList.contains("nav-solid");
  function onScroll() {
    if (!nav) return;
    if (forceSolid || window.scrollY > 28) nav.classList.add("solid");
    else nav.classList.remove("solid");
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- 移动菜单 ---------- */
  var toggle = document.querySelector(".nav-toggle");
  var menu = document.querySelector(".mobile-menu");
  if (toggle && menu) {
    toggle.addEventListener("click", function () {
      menu.classList.toggle("open");
      toggle.textContent = menu.classList.contains("open") ? "✕" : "☰";
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("open");
        toggle.textContent = "☰";
      });
    });
  }

  /* ---------- 滚动 REVEAL（淡入 + 轻微上移） ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  function revealAll() {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
    // 失败安全:某些渲染路径(截图/打印/PDF/离线导出)IO 不触发回调，
    // 兜底强制显示，确保内容永不卡在隐藏态。
    setTimeout(revealAll, 1400);
  } else {
    revealAll();
  }

  /* ---------- 动画视频：只在视口附近播放，离开就暂停（2026-09-07 滚动性能改修） ---------- */
  var vids = document.querySelectorAll("video[data-autoplay]");
  function playVid(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if ("IntersectionObserver" in window && vids.length) {
    var vio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) playVid(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      },
      { rootMargin: "160px 0px 160px 0px", threshold: 0 }
    );
    vids.forEach(function (v) { vio.observe(v); });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { vids.forEach(function (v) { v.pause(); }); }
      else { vids.forEach(function (v) { var b = v.getBoundingClientRect(); if (b.bottom > -160 && b.top < innerHeight + 160) playVid(v); }); }
    });
  } else {
    vids.forEach(playVid);
  }

  /* ---------- 数字递增（[data-count]） ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dec = (el.getAttribute("data-dec") || "0") | 0;
    var dur = 1100, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(dec);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-count]");
  if ("IntersectionObserver" in window && counters.length) {
    var cio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- 锚点高亮当前区（index 内 #section 导航） ---------- */
  var anchorLinks = Array.prototype.slice
    .call(document.querySelectorAll(".nav-center a[href^='#']"));
  if (anchorLinks.length && "IntersectionObserver" in window) {
    var sections = anchorLinks
      .map(function (a) { return document.querySelector(a.getAttribute("href")); })
      .filter(Boolean);
    var current = null;
    var sio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) current = e.target.id;
        });
        anchorLinks.forEach(function (a) {
          a.classList.toggle("active", a.getAttribute("href") === "#" + current);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    sections.forEach(function (s) { sio.observe(s); });
  }

  /* ---------- HERO 分镜:标语→产品→场景 依次推进 ---------- */
  var hero = document.querySelector(".hero");
  if (hero) {
    // 1) 标语依次浮现
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add("lit"); });
    });
    // 2) 产品方块浮入
    var cube = hero.querySelector(".hero-cube");
    if (cube) setTimeout(function () { cube.classList.add("in"); }, 100);

    // 3) 场景轮换（更慢、更克制）
    var slides = hero.querySelectorAll(".hero-slide");
    var copySlides = hero.querySelectorAll(".hero-copy-slide");
    var dots = hero.querySelectorAll(".hero-dots span");
    if (slides.length > 1) {
      var i = 0, timer = null;
      function go(n) {
        slides[i].classList.remove("active");
        if (copySlides[i]) {
          copySlides[i].classList.remove("active");
          copySlides[i].setAttribute("aria-hidden", "true");
        }
        if (dots[i]) dots[i].classList.remove("on");
        i = (n + slides.length) % slides.length;
        slides[i].classList.add("active");
        if (copySlides[i]) {
          copySlides[i].classList.add("active");
          copySlides[i].removeAttribute("aria-hidden");
        }
        if (dots[i]) dots[i].classList.add("on");
      }
      function play() { timer = setInterval(function () { go(i + 1); }, 5200); }
      dots.forEach(function (d, idx) {
        d.addEventListener("click", function () {
          clearInterval(timer); go(idx); play();
        });
      });
      play();
    }
  }
  /* ---------- APP 手机截图轮播（圆形滚动 / 无缝循环） ---------- */
  (function () {
    var phone = document.querySelector(".app-phone");
    if (!phone) return;
    var track = phone.querySelector(".app-track");
    var dots = phone.querySelectorAll(".app-dots span");
    if (!track) return;
    var slides = track.querySelectorAll("img");
    var n = slides.length;
    if (n < 2) return;

    // 末尾にクローンを追加して無縫ループ
    var clone = slides[0].cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    track.appendChild(clone);
    var total = n + 1;
    track.style.width = total * 100 + "%";
    slides = track.querySelectorAll("img");
    slides.forEach(function (im) { im.style.flexBasis = 100 / total + "%"; });

    var i = 0, dur = 2600, anim = ".75s cubic-bezier(.7,0,.2,1)", busy = false;
    function setTransition(on) {
      track.style.transition = on ? "transform " + anim : "none";
    }
    function place() {
      track.style.transform = "translateX(-" + (i * (100 / total)) + "%)";
    }
    function lightDots() {
      var active = i % n;
      dots.forEach(function (d, k) { d.classList.toggle("on", k === active); });
    }
    setTransition(true);
    function next() {
      if (busy) return;
      busy = true;
      i++;
      setTransition(true);
      place();
      lightDots();
      if (i === total - 1) {
        // クローンに到達 → トランジション後に瞬間リセット
        var onEnd = function () {
          track.removeEventListener("transitionend", onEnd);
          setTransition(false);
          i = 0;
          place();
          // reflow を強制して transition を復帰
          void track.offsetWidth;
          setTransition(true);
          busy = false;
        };
        track.addEventListener("transitionend", onEnd);
      } else {
        var onEnd2 = function () {
          track.removeEventListener("transitionend", onEnd2);
          busy = false;
        };
        track.addEventListener("transitionend", onEnd2);
      }
    }
    place();
    lightDots();
    var timer = setInterval(next, dur);
    // タブ非表示中は停止（パフォーマンス）
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { clearInterval(timer); }
      else { clearInterval(timer); timer = setInterval(next, dur); }
    });
  })();
})();
